import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=768e628f"
import script from "./MoreInformation.vue?vue&type=script&lang=ts"
export * from "./MoreInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports